type IChatSupabaseModule = typeof import('@supabase/supabase-js');

let chatSupabaseModule: IChatSupabaseModule | null = null;

export const loadChatSupabaseModule = async (): Promise<IChatSupabaseModule> => {
    if (!chatSupabaseModule) {
        chatSupabaseModule = await import('@supabase/supabase-js');
    }
    return chatSupabaseModule;
};
